import styled from 'styled-components';

export const StyledRecaptchaInput = styled.div`
  height: 78px;
`;
